import BasicI18nSetup from 'I18n/init/setup/BasicI18nSetup';
import lang from 'i2l?query=sporks!../../lang/en.lyaml';
import useInterval from 'in-meeting-experience-ui-components/hooks/useInterval';
import captureException from 'in-meeting-experience-ui-components/utils/captureException';
import { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { routes } from '../constants/routes';
import { REFRESH_COOKIE_TIMEOUT } from '../constants/timeouts';
import { portalUserInfo } from '../slices/auth/actions';
const usePortalUserInfo = () => {
  const {
    push
  } = useHistory();
  const params = useParams();
  const portalIdRef = useRef(+params.portalId);
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);
  useInterval(() => dispatch(portalUserInfo(true)), REFRESH_COOKIE_TIMEOUT, {
    forceRefresh: true
  });

  // prevent fetch app comtext for not valid portalId
  useEffect(() => {
    if (Number.isNaN(portalIdRef.current)) {
      push(routes.home);
    }
  }, [push]);

  // if portalId is a number we can fetch app context for portal
  useEffect(() => {
    if (!Number.isNaN(portalIdRef.current)) {
      setIsLoading(true);
      dispatch(portalUserInfo()).then(data => {
        if (data.meta.requestStatus === 'fulfilled') {
          const {
            user
          } = data.payload;
          return BasicI18nSetup.setup({
            lang,
            user: user.locale,
            portal: {}
          });
        }
        return BasicI18nSetup.setup({
          lang,
          user: {
            langEnabled: true
          },
          portal: {}
        });
      }).catch(captureException).finally(() => {
        setIsLoading(false);
      });
    }
  }, [dispatch]);
  return isLoading;
};
export default usePortalUserInfo;